export function StartOfWeek(date) {
    var diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
    return new Date(date.setDate(diff));
  }
  
export function month_name(dt) {
    let mlist = ["Janvier", "Février", "Mars", "d'Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    return mlist[dt.getMonth()];
}